// extracted by mini-css-extract-plugin
export default {"Title":"SectionLabel_Title__bvo2r","Description":"SectionLabel_Description__tEIZs"};